var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m4 8h5 6 5v2h-16zm7.2261-5.00887.7739.77388.7739-.77388c.0687-.07604.1412-.14856.2172-.21725l.0089-.00887v.00089c.5312-.47602 1.2324-.7659 2-.7659 1.654 0 3 1.346 3 3 0 .35045-.0604.68708-.1714 1h4.1714v6h-1v7.087c0 1.055-.858 1.913-1.913 1.913h-14.174c-1.055 0-1.913-.858-1.913-1.913v-7.087h-1v-6h4.17141c-.11098-.31292-.17141-.64955-.17141-1 0-1.654 1.346-3 3-3 .76758 0 1.4688.28988 2 .7659v-.00089l.0089.00887c.076.06869.1485.14121.2172.21725zm4.7739 2.00887c0 .551-.448 1-1 1s-1-.449-1-1 .448-1 1-1 1 .449 1 1zm-8 0c0 .551.448 1 1 1s1-.449 1-1-.448-1-1-1-1 .449-1 1zm-3 7v7h6v-7zm8 0v7h6v-7z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
export default SvgGiftreact;